import { html } from 'fxjs/es';

const mui_ref_path = '/modules/VectorEditor/Sticker/Free/Mobile/S/Mui/tab.js';
/*
 * 서버와 프론트에서 사용될 옵션입니다.
 * https://www.notion.so/marpple/Marpple-UI-80875a30a63e436382a02e2d820f4695#3bf02d1d08ed4eb9ac2b8656b513d154
 * */
export const tab = {
  tab_name: mui_ref_path,
  el_id: '', // tab element id 추가
  el_class: '', // tab element class 추가
  tag: '', // 커스텀 태그
  title: '', // tab button의 title
  selected: false, //탭이 여러개일때 먼저 선택되어있을 tab, tab이 하나면 true가 됨, tab이 여러개인데 모두 false면 맨 첫번째가 true
  attrs: {}, // tab 엘리먼트에 들어갈 어트리뷰트 지정 (id, class 등 자유롭게 추가가능)
  makeData(tab) {}, // template 함수 인자에 들어갈 값, 반드시 MuiB.ssr 함수안에서 동적으로 정의되어야함.
  template(data) {
    return html`
      <div class="editor_container"></div>

      <div class="header" data-is_show="true">
        <button type="button" class="cancel">${T('modules::VectorEditor::Sticker::FreeGrid::취소')}</button>
        <span class="title"></span>
        <button type="button" class="done">${T('modules::VectorEditor::Sticker::FreeGrid::완료')}</button>
      </div>

      <div class="footer none" data-is_show="true" data-icon_type="set_background">
        <button class="icon"></button>
        <span class="label_text">${T('modules::VectorEditor::Sticker::FreeGrid::배경 설정')}</span>
      </div>
      <div class="footer none" data-is_show="true" data-icon_type="make_sticker">
        <button class="icon"></button>
        <span class="label_text">${T('modules::VectorEditor::Sticker::FreeGrid::스티커 추가')}</span>
      </div>

      <div class="footer select" data-is_show="false" data-icon_type="edit_sticker">
        <button type="button" class="icon"></button>
        <span class="label_text">${T('modules::VectorEditor::Sticker::FreeGrid::편집')}</span>
      </div>
      <div class="footer select" data-is_show="false" data-icon_type="duplicate">
        <button type="button" class="icon"></button>
        <span class="label_text">${T('modules::VectorEditor::Sticker::FreeGrid::복제')}</span>
      </div>
      <div class="footer select" data-is_show="false" data-icon_type="delete">
        <button type="button" class="icon"></button>
        <span class="label_text">${T('modules::VectorEditor::Sticker::FreeGrid::삭제')}</span>
      </div>

      <div class="blank_plate" data-is_show="false"></div>
    `;
  }, // 탭에 들어갈 html 을 그리는 함수
};
